import ShopCities from "../symbols/getShopCities";
import { HttpRequestGet } from "../../service";

const getShopCitiesAction = () => ({
  type: ShopCities.GET_SHOP_CITIES,
});
const getShopCitiesSuccessAction = (data: any) => {
  return {
    type: ShopCities.GET_SHOP_CITIES_SUCCESS,
    payload: data,
  };
};
const getShopCitiesFailureAction = (data: any) => ({
  type: ShopCities.GET_SHOP_CITIES_FAILURE,
  payload: {
    data,
  },
});
const clearShopCitiesAction = () => ({
  type: ShopCities.CLEAR_SHOP_CITIES,
});

export function getShopCities() {
  return (dispatch: any) => {
    dispatch(getShopCitiesAction());
    HttpRequestGet(
      `/merchant/city`,
      dispatch,
      getShopCitiesSuccessAction,
      getShopCitiesFailureAction,
      true,
      () => {}
    );
  };
}
export function clearShopCities() {
  return (dispatch: any) => {
    dispatch(clearShopCitiesAction());
  };
}
